import { render, staticRenderFns } from "./MailSolutionCostsTable.vue?vue&type=template&id=98702034&scoped=true&"
import script from "./MailSolutionCostsTable.vue?vue&type=script&lang=js&"
export * from "./MailSolutionCostsTable.vue?vue&type=script&lang=js&"
import style0 from "./MailSolutionCostsTable.vue?vue&type=style&index=0&id=98702034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98702034",
  null
  
)

export default component.exports